import type { AccountantStatusBillsDetailEntity } from "../entities/AccountantStatusEntity";
import type {
  AccountantStatusPaginatedMonthParams,
  AccountantStatusRepository,
} from "../repositories/AccountantStatusRepository";

export class GetAccountantStatusMonthDetailBillsUseCase {
  constructor(private readonly repository: AccountantStatusRepository) {}

  async execute(
    params: AccountantStatusPaginatedMonthParams,
  ): Promise<AccountantStatusBillsDetailEntity> {
    return this.repository.getMonthDetailBills(params);
  }
}
